import { css } from '@emotion/css';
import { Button, ButtonProps, Modal, styled } from '@mui/material';
import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setOpenedCloseSurveyModal, setTemporaryLinkText } from 'store/questionnaireSlice';
import { RootState } from 'store/store';
import { colors } from 'styles/colors';

const ColorButtonCancel = styled(Button)<ButtonProps>(() => ({
    color: '#000',
    backgroundColor: 'white',
    width: '6rem',
    height: '2.4rem',
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: 'Figtree',
    padding: '5px',
    textTransform: 'none',
    '&:hover': {
        backgroundColor: 'white',
    },
    borderRadius: '0.5rem',
}));

const ColorButtonConfirm = styled(Button)<ButtonProps>(() => ({
    color: 'white',
    backgroundColor: colors.primaryButtonBackground,
    width: '6rem',
    height: '2.4rem',
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: 'Figtree',
    padding: '5px',
    textTransform: 'none',
    '&:hover': {
        backgroundColor: colors.primaryButtonBackground,
    },
    borderRadius: '0.5rem',
}));

const CloseSurveyModal = memo(() => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const openedCloseSurveyModal = useSelector((state: RootState) => state.questionaire.openedCloseSurveyModal);
    const temporaryLinkText = useSelector((state: RootState) => state.questionaire.temporaryLinkText);

    const confirmSurveyClose = useCallback(async () => {
        dispatch(setOpenedCloseSurveyModal(false));

        if (temporaryLinkText !== '') {
            navigate('/time-line');
            dispatch(setTemporaryLinkText(''));
        } else {
            navigate('/questionnaries-list');
        }
    }, [dispatch, navigate, temporaryLinkText]);

    const onClose = useCallback(async () => {
        dispatch(setOpenedCloseSurveyModal(false));
    }, [dispatch]);

    return (
        <Modal
            sx={{ border: 'none', outline: 'none' }}
            open={openedCloseSurveyModal}
            onClose={onClose}
            style={{ backgroundColor: 'none' }}
            BackdropProps={{ style: { backgroundColor: 'transparent' } }}
        >
            <div className={styles.infoModal}>
                <div className={styles.modalContent}>
                    <div className={styles.modalBody}>
                        {
                            'Er du sikker på, at du vil afbryde besvarelsen af dette spørgeskema? Dine svar vil ikke blive gemt'
                        }
                    </div>
                    <div className={styles.modalFooter}>
                        <div className={styles.button}>
                            <ColorButtonCancel variant="contained" onClick={onClose}>
                                Nej
                            </ColorButtonCancel>
                        </div>
                        <div className={styles.button}>
                            <ColorButtonConfirm variant="contained" onClick={confirmSurveyClose}>
                                Ja
                            </ColorButtonConfirm>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
});
const styles = {
    infoModal: css({
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '300px',
        backgroundColor: colors.backgroundLight,
        borderRadius: '10px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        padding: '1.5rem',
        outline: 'none',
    }),
    modalContent: css({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    }),
    modalBody: css({
        flex: 1,
        marginBottom: '1.5rem',
        fontSize: '1rem',
        color: colors.primaryText,
        textAlign: 'left',
        fontFamily: 'Figtree',
    }),
    modalFooter: css({
        display: 'flex',
        justifyContent: 'space-between',
    }),
    button: css({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'Figtree',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: 'normal',
    }),
};

export default CloseSurveyModal;
